import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import ImagePanel from '@components/ImagePanel/ImagePanel';
import SubscribeForm from './SubscribeForm/SubscribeForm';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import ImportImages from '@src/importImages';

const Image = ImportImages('/subscribe/subscribe.jpg');

class Subscribe extends Component {
  render = () => {
    const containerProps = {
      pageHeight: this.props.pageHeight
    };
    containerProps.autoScroll = {
      active: 1,
      delay: 1000
    };
    return (
      <Fragment>
        <Helmet>
          <title>Subscribe | JetSuite</title>
          <meta
            name="description"
            content={'Sign Up for JetSuite News & Updates'}
          />
        </Helmet>
        <ScrollContainer {...containerProps}>
          <ImagePanel
            id={'subscribe-imagepanel'}
            screenHeight={this.props.pageHeight}
            image={Image}
            alt={'Subscribe'}
          />

          {this.props.pageWidth > 991 ? (
            <CloudPanel
              id={'leadership-cloudpanel'}
              hideJSILogo={true}
              screenHeight={this.props.pageHeight}
            >
              <SubscribeForm
                id={'subscribe-form'}
                pageWidth={this.props.pageWidth}
                pageHeight={this.props.pageHeight}
              />
            </CloudPanel>
          ) : (
            <SubscribeForm
              id={'subscribe-form'}
              pageWidth={this.props.pageWidth}
              pageHeight={this.props.pageHeight}
            />
          )}
        </ScrollContainer>
      </Fragment>
    );
  };
}

export default Subscribe;



// WEBPACK FOOTER //
// ./src/components/Subscribe/Subscribe.jsx